import { UPDATE_ANNOTATIONS } from './actions';

export default (previousState =[], { type, payload }) => {
  switch (type) {
    case UPDATE_ANNOTATIONS:
      return payload;
    default:
      return previousState;
  }
};